var map = {
	"./UP_DOCHOI_ACTIVE.png": 3170,
	"./UP_DONGHO_ACTIVE.png": 8395,
	"./UP_DT&PK_ACTIVE.png": 2825,
	"./UP_GIAYNAM_ACTIVE.png": 4376,
	"./UP_GIAYNU_ACTIVE.png": 2054,
	"./UP_ME&BE_ACTIVE.png": 1597,
	"./UP_NHACUA&DOISONG_ACTIVE.png": 7618,
	"./UP_PHUKIENTHOITRANG_ACTIVE.png": 3479,
	"./UP_THETHAO&DULICH_ACTIVE.png": 2471,
	"./UP_THOITRANGNAM_ACTIVE.png": 6808,
	"./UP_THOITRANGNU_ACTIVE.png": 5588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7626;